import {Component, OnInit, ViewEncapsulation, Optional, Inject, ViewChild, AfterViewChecked, ChangeDetectorRef} from '@angular/core';
import {MotivoRechazoCreateService} from './service/motivo-rechazo-create.service';
import {FormGroup} from '@angular/forms';
import {MessageCrudService, EvkCreateComponentBase} from '@evomatik/evk-common';
import {MotivoRechazoFormComponent} from '../motivo-rechazo-form/motivo-rechazo-form.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
@Component({
    selector: 'lib-motivo-rechazo-create',
    templateUrl: './motivo-rechazo-create.component.html',
    styleUrls: ['./motivo-rechazo-create.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class MotivoRechazoCreateComponent extends EvkCreateComponentBase<any> implements OnInit, AfterViewChecked {

    public form: FormGroup;
    public idDiligencia: string;
    public idDiligenciaConfig: string;
    public createdBy: string;
    public observaciones: string;
    public canEnviar = false;
    public tarea: any;
    public diligencia: any;
    public clasificacion: any;
    constructor(
        public createService: MotivoRechazoCreateService,
        public message: MessageCrudService,
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<MotivoRechazoCreateComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
        public changeDetector: ChangeDetectorRef,

    ) {
        super(createService, message);
        this.diligencia = data.diligencia;
        this.createdBy = data.createdBy;
        this.observaciones = data.observaciones;
        this.idDiligenciaConfig = this.diligencia.idDiligenciaConfig;
        if (this.diligencia != null && this.diligencia !== undefined){
            this.clasificacion = this.diligencia.clasificacion;
            this.idDiligencia = this.diligencia.id;
        }

    }

    ngOnInit() {
        this.createService.doneSave = this.closeDialog;
    }

    public closeDialog = () => {
        this.dialogRef.close({data: true});
    }

    public get formValid() {
        return this.form !== undefined && this.form.valid;
    }

    @ViewChild(MotivoRechazoFormComponent, {static: false})
    set formComponent(rechazarForm: MotivoRechazoFormComponent) {
        this.form = rechazarForm.form;
        if (this.observaciones !== null && this.observaciones !== undefined) {
            this.form.controls['observaciones'].setValue(this.observaciones);
            this.form.controls['observaciones'].disable();
        } else {
            this.canEnviar = true;
        }
        this.changeDetector.detectChanges();
    }

    ngAfterViewChecked(): void {
        //
    }
}
